import Styles from 'src/components/Styles';

export function getStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    gradientBackground: {
      flex: 1,
    },
    title: {
      fontSize: Styles.Fonts.headerFont,
      fontWeight: '700',
      color: Styles.Colors.PayNew.black01,
      textAlign: 'center',
    },
    text: {
      fontSize: Styles.Fonts.sectionHeader,
      textAlign: 'center',
      color: Styles.Colors.PayNew.black01,
      fontWeight: '400',
      lineHeight: 20,
    },
    amount: {
      fontSize: Styles.Fonts.f6 - 3.34,
      paddingVertical: Styles.Spacing.m3,
      fontWeight: '700',
      textAlign: 'center',
    },
    buttonStyle: {
      alignSelf: 'center',
      marginTop: 60,
      justifyContent: 'center',
    },
    minimumPurchaseText: {
      color: Styles.Colors.PayNew.black01,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      lineHeight: 20,
      fontStyle: 'italic',
      textAlign: 'center',
    },
    offerExpiresText: {
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m3,
      textAlign: 'center',
      fontWeight: '400',
      lineHeight: 20,
      fontSize: Styles.Fonts.f8,
      color: Styles.Colors.PayNew.black01,
    },
    gapVertical: {marginTop: 40},
    horizontalGap: {
      marginHorizontal: 40,
    },
    imageContainer: {
      position: 'absolute',
      top: -50,
      left: 0,
      right: 0,
      alignItems: 'center',
      zIndex: 1,
    },
    buttonFontSize: {
      fontSize: Styles.Fonts.f7,
    },
  };
}

export default {
  getStyleDescriptor,
};
